import { PageHeader, Textarea } from '../ui';
import { useBinder } from '../../lib/useBinder';
import { useRunStore } from '../../store/runStore';
import shared from './sections.module.css';

/** Free-form DM notes for the current run. Autosaves via the run store. */
export function NotesSection() {
  const ctx = useBinder();
  const setNotes = useRunStore((s) => s.setNotes);
  const saving = useRunStore((s) => s.saving);
  if (!ctx) return null;

  return (
    <div>
      <PageHeader
        eyebrow="Note del DM"
        title="Note"
        subtitle={saving ? 'Salvataggio…' : 'Salvate automaticamente'}
      />
      <p className={shared.lead}>
        Appunti privati per questa sessione. Vengono salvati con la sessione e li ritrovi quando la
        riprendi.
      </p>
      <Textarea
        value={ctx.state.notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder="Scrivi qui le tue note…"
        rows={18}
        style={{ minHeight: '50vh' }}
      />
    </div>
  );
}
